import passwordValidationClasses from '@/config/passwordValidationClasses'

export function getPasswordValidationRules(minClasses: number, minLength: number) {
    return passwordValidationClasses.slice(0, minClasses).join('|').concat('|required').concat(`|length:${minLength}`)
}
